// removed by extract-text-webpack-plugin
module.exports = {"ui":"clipboard_ui_1eu3aa","fade":"clipboard_fade_c1u0a0"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/clipboard/clipboard.scss
// module id = 545
// module chunks = 0